<template>
    <div class="table_wrap">
        <div class="pagnation_wrap">
            <el-pagination v-if="paginationData.total > 0"
                           :page-size="paginationData.size"
                           :current-page.sync="page"
                           :pager-count="11"
                           layout="prev, pager, next"
                           :total="paginationData.total"
                           @current-change="changePage('page', page)"
            ></el-pagination>
        </div>

        <div class="table_search row has_bc">
            <el-row>
                <el-col :span="12" >
                </el-col>
                <el-col :span="12" class="text_right">
                    <el-select v-model="size" @change="changePage('size', size)">
                        <el-option v-for="(sizeData) in sizeList" :key="`size${sizeData}`" :value="sizeData" :label="`${sizeData}개씩 보기`"></el-option>
                    </el-select>
                </el-col>
            </el-row>
        </div>
    </div>
</template>
<script>
    import {mapGetters, mapState} from "vuex";
    import EventBus from "@/utils/event-bus";
    export default {
        name: 'PaginationtDefaultLayout',
        mixins: [],
        components: {
        },
        props: {
            paginationData: {
                type: Object,
                default: {
                    total: 0,
                    page: 0,
                    size: 0,
                }
            },
            setPage: {
                type: Function,
                default: () => {}
            },
            type: {},
            listLength: {
                type: Number,
                default: 0
            }
        },
        data() {
            return{
                page: 1,
                size: 10,
                sizeList: [10, 30, 50]
            }
        },
        beforeRouterEnter() {},
        created() {
        },
        mounted() {
            this.page = this.paginationData.page;
            this.size = this.paginationData.size;
        },
        beforeDestroy() {
        },
        destroyed() {},
        computed: {
        },
        methods: {
            changePage(key, value) {
                this.setPage(key, value);
            },
        },
        watch: {
            'paginationData.page': {
                deep: true,
                handler: function (val, oldVal) {
                    this.page = this.paginationData.page;
                }
            }
        },
    }
</script>